import styled from "@emotion/styled";
export default styled("div")`
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  align-items: stretch;
  flex: 1 1 auto;
`;
